
export const aiToolTemplate = {
    backToWorkbench: '返回工作台',
    uploadImage: '上传图片',
    uploadImageDescription: '支持 JPG、PNG 格式，最大 10MB',
    clickOrDragUpload: '点击或拖拽上传图片',
    uploadSuggestion: '建议使用清晰的图片以获得最佳效果',
    
    // 文生图相关
    enterPrompt: '输入提示词',
    enterPromptDescription: '请输入描述您想要生成图片的提示词',
    promptPlaceholder: '请输入您想要生成的图片描述...',
    enterPromptFirst: '请先输入提示词',

    supplementaryPrompt: '补充提示词',
    supplementaryPromptDescription: '添加额外的描述来微调生成结果（可选）',
    enterSupplementaryPrompt: '请输入补充提示词...',
    
    generationResult: '生成结果',
    resultCompleted: '您的{toolName}已生成完成',
    resultWaiting: '上传图片并点击生成按钮开始创作',
    waitingGeneration: '等待生成',
    waitingDescription: '上传图片后，生成的{toolName}将在这里显示',
    startGeneration: '开始生成',
    generating: '生成中',
    downloadImage: '下载图片',
    downloadAllImages: '下载所有图片',
    downloadStarted: '开始下载图片',
    downloadFailed: '下载失败，请稍后重试',
    generationFailed: '生成失败，请稍后重试',
    // 新增的硬编码文本翻译
    uploadImageFirst: '请先上传一张图片',
    generationStarted: '图片生成已开始，请稍候...',
    generationSuccess: '图片生成成功！',
    promptRequired: '请输入提示词',
    generationTimeout: '生成超时，请稍后重试',
    generationStatusError: '生成状态异常',
    pollStatusFailed: '查询生成状态失败',
    generationStatusAbnormal: '生成状态异常',
    
    // SizeSelector component translations
    generationSettings: '生成设置',
    model: '模型',
    aspectRatio: '图像比例',
    resolution: '分辨率',
    
    // PromptInput 组件翻译
    promptInput: {
      defaultTitle: '输入提示词',
      defaultPlaceholder: '请输入您的提示词...',
      validation: {
        required: '此栏位为必填项',
        minLength: '至少需要 {min} 个字符',
        maxLength: '不能超过 {max} 个字符',
        pattern: '输入格式不正确'
      },
      suggestions: {
        toggle: '查看提示词建议',
        title: '提示词建议'
      }
    },
    
    // ImageUpload 组件翻译
    imageUpload: {
      defaultTitle: '上传图片',
      defaultDescription: '支持 JPG、PNG、GIF 格式，最大 10MB',
      referenceTitle: '上传参考图片',
      referenceDescription: '上传一张参考图片来指导Logo设计风格',
      referencePlaceholder: '点击上传参考图片',
      dragDropText: '拖拽图片到此处，或',
      clickToUpload: '点击上传',
      uploading: '上传中...',
      addMore: '添加更多图片',
      removeImage: '移除图片',
      validation: {
        required: '请上传至少一张图片',
        fileSize: '文件大小不能超过 {maxSize}MB',
        fileType: '不支持的文件格式，请上传 {allowedTypes}',
        maxFiles: '最多只能上传 {max} 张图片',
        uploadFailed: '上传失败，请重试'
      }
    },
    
    // ColorPicker 组件翻译
    colorPicker: {
      defaultTitle: '选择颜色',
      defaultDescription: '选择背景颜色或输入自定义颜色值',
      currentColor: '当前颜色',
      noColorSelected: '未选择颜色',
      showPalette: '显示调色板',
      hidePalette: '隐藏调色板',
      presetColors: '预设颜色',
      customColor: '自定义颜色',
      colorInput: '颜色值',
      clearColor: '清除颜色',
      selectedColor: '选中颜色',
      none: '无',
      hexPlaceholder: '输入十六进制颜色值',
      validation: {
        required: '请选择一个颜色',
        invalidFormat: '无效的颜色格式，请使用 #RRGGBB 格式'
      }
    },

    placePicker: {
      validation: {
        required: '请选择一个位置'
      }
    },
    
    // 错误消息
    fileTooLarge: '文件大小不能超过 10MB',
    invalidFileType: '请上传 JPG、PNG 或 GIF 格式的图片',
    uploadFailed: '上传失败，请重试',
    networkError: '网络错误，请检查网络连接',
    serverError: '服务器错误，请稍后重试',
    // 工具名稱和描述
    tools: {
      watercolor: {
        name: '水彩画风格',
        description: '将您的图片转换为柔和透明的水彩画艺术效果，营造梦幻浪漫的视觉体验'
      },
      sketch: {
        name: '素描风格',
        description: '将您的图片转换为精致的素描艺术作品，展现线条的力量与美感'
      },
      cyberpunk: {
        name: '赛博朋克风格',
        description: '将您的图片转换为未来科技感的赛博朋克艺术风格，营造炫酷的科幻氛围'
      },
      popArt: {
        name: '波普艺术肖像',
        description: '将您的肖像转换为鲜艳大胆的波普艺术风格，展现现代艺术的魅力'
      },
      anime: {
        name: '动漫风格转换',
        description: '将您的图片转换为精美的动漫风格，体验二次元的魅力世界'
      },
      faceSwap: {
        name: 'AI 捏脸',
        description: '上传一张包含人脸的图片，即可生成不同风格的头像'
      },
      oilPainting: {
        name: '油画风格',
        description: '将您的图片转换为经典的油画艺术作品，展现传统绘画的厚重质感'
      },
      professionalPortrait: {
        name: '职业肖像照',
        description: '将您的照片转换为专业的商务肖像，适合LinkedIn、企业网站或名片使用',
        clothingStyle: '服装风格',
        clothingStyleDesc: '选择肖像照的职业服装',
        styles: {
          default: '默认 (深色西装)',
          darkSuit: '深色西装',
          lightSuit: '浅色西装',
          shirt: '商务衬衫',
          casual: '商务休闲',
          tuxedo: '燕尾服/礼服',
          polo: 'Polo衫',
          dress: '职业连衣裙',
          blazer: '西装外套+T恤'
        }
      },
      idPhotoGeneration: {
        name: '证件照生成',
        description: '将您的照片转换为标准的证件照，支持多种尺寸和背景颜色'
      },
      photoRestoration: {
        name: '老照片修复',
        description: '修复老旧、损坏或褪色的照片，去除划痕、污渍和瑕疵，恢复照片原有的清晰度和色彩',
        uploadTitle: '上传老照片',
        uploadDescription: '支持 JPG、PNG、GIF 格式，最大 10MB',
        uploadPlaceholder: '点击或拖拽上传需要修复的老照片'
      },
      emojiPack: {
        name: '表情包制作',
        description: '上传一张图片，智能生成一整套风格统一的表情包，涵盖多种表情与动作，适合聊天、社交平台使用'
      }
    }
  };
